import { Option } from '@cmg/common';
import isNil from 'lodash/isNil';

import {
  InterestLevelInterestUnit,
  InterestLevelLimitType,
  OrderBookState,
} from '../../../graphql';

export const interestUnitLabels: Record<InterestLevelInterestUnit, string> = {
  [InterestLevelInterestUnit.Currency]: 'Currency',
  [InterestLevelInterestUnit.Percent]: 'Percent',
  [InterestLevelInterestUnit.Shares]: 'Shares',
  [InterestLevelInterestUnit.Bonds]: 'Bonds',
};

export const getInterestUnitOptions = (
  sharesLabelOverwrite: string | null
): Option<InterestLevelInterestUnit>[] => [
  {
    label: interestUnitLabels[InterestLevelInterestUnit.Currency],
    value: InterestLevelInterestUnit.Currency,
  },
  {
    label: interestUnitLabels[InterestLevelInterestUnit.Percent],
    value: InterestLevelInterestUnit.Percent,
  },
  {
    label: !isNil(sharesLabelOverwrite)
      ? sharesLabelOverwrite
      : interestUnitLabels[InterestLevelInterestUnit.Shares],
    value: InterestLevelInterestUnit.Shares,
  },
];

export const limitTypeLabels: Record<InterestLevelLimitType, string> = {
  [InterestLevelLimitType.Price]: 'Price',
  [InterestLevelLimitType.Discount]: 'Discount',
  [InterestLevelLimitType.Premium]: 'Premium',
};

export const orderBookStateLabels: Record<OrderBookState, string> = {
  [OrderBookState.Open]: 'Open',
  [OrderBookState.Closed]: 'Closed',
  [OrderBookState.NeverOpened]: 'Awaiting Offering Publish',
};
